const extensionHelpButton = document.getElementById('extensionHelpBtn');
const extensionDialog = document.getElementById('extensionInstallDialog');
const closeExtensionButton = document.getElementById('closeExtensionInstallBtn');
const finishExtensionButton = document.getElementById('finishExtensionInstallBtn');
const copyAddressButton = document.getElementById('copyChromeExtensionsBtn');
const copyAddressStatus = document.getElementById('copyChromeExtensionsStatus');

const CHROME_EXTENSIONS_ADDRESS = 'chrome://extensions';

function openExtensionDialog() {
  if (!extensionDialog) return;
  extensionDialog.inert = false;
  extensionDialog.removeAttribute('inert');
  extensionDialog.classList.remove('hidden');
  extensionDialog.setAttribute('aria-hidden', 'false');
  document.body.classList.add('modal-open');
  closeExtensionButton?.focus();
}

function closeExtensionDialog() {
  if (!extensionDialog) return;
  const active = document.activeElement;
  if (active && extensionDialog.contains(active) && typeof active.blur === 'function') active.blur();
  extensionDialog.inert = true;
  extensionDialog.setAttribute('inert', '');
  extensionDialog.classList.add('hidden');
  extensionDialog.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('modal-open');
  extensionHelpButton?.focus({ preventScroll:true });
}

async function copyChromeExtensionsAddress() {
  if (!copyAddressStatus) return;

  try {
    await navigator.clipboard.writeText(CHROME_EXTENSIONS_ADDRESS);
    copyAddressStatus.textContent = 'Adres skopiowany. Wklej go w pasku adresu Chrome.';
    copyAddressStatus.className = 'extension-copy-status ok';
  } catch {
    copyAddressStatus.textContent = 'Nie udało się skopiować automatycznie. Zaznacz adres i skopiuj go ręcznie.';
    copyAddressStatus.className = 'extension-copy-status error';
  }
}

extensionHelpButton?.addEventListener('click', openExtensionDialog);
closeExtensionButton?.addEventListener('click', closeExtensionDialog);
finishExtensionButton?.addEventListener('click', closeExtensionDialog);
copyAddressButton?.addEventListener('click', copyChromeExtensionsAddress);

extensionDialog?.addEventListener('click', event => {
  if (event.target === extensionDialog) closeExtensionDialog();
});

document.addEventListener('keydown', event => {
  if (event.key === 'Escape' && !extensionDialog?.classList.contains('hidden')) {
    closeExtensionDialog();
  }
});
